export default __webpack_public_path__ + "static/media/review.e1d66b06.jpg";